// src/modules/app-views/toolbox/service.js
// *****************************************************************************
// TOOLBOX SERVICE - Tool Cataloging
// *****************************************************************************

import axiosService from 'services/axiosService';
import { API } from 'constants/Api';
import { mergeUrlParamsQuery } from 'utils/urlUtils';

// *****************************************************************************
// CATALOG TOOLS
// *****************************************************************************

/**
 * Catalogs a tool using AI
 */
export const catalogTool = async ({
  toolDescription,
  model,
  requestOrigin = 0,
}) => {
  const [doc, result] = await axiosService.post({
    url: API.TOOLBOX.IA_CATALOG,
    data: {
      toolDescription,
      model,
      requestOrigin,
    },
    returnAsObject: true,
    timeout: 120000, // 2 minutes - AI cataloging can take longer
  });

  return result;
};

// *****************************************************************************
// ADD TO SET (array operations)
// *****************************************************************************

/**
 * Add, update, or remove items from an array field in a toolbox document
 */
export const toolboxAddToSet = async ({ _id, operator, path, data }) => {
  const url = mergeUrlParamsQuery({
    url: API.TOOLBOX.ADD_TO_SET,
    params: { _id, operator, path },
  });

  const [result] = await axiosService.put({
    url,
    data,
    headers: { 'x-resultasobject': true },
  });

  return result;
};

// *****************************************************************************
// PRICES
// *****************************************************************************

/**
 * Get AI model prices for tool cataloging
 */
export const getAiPrices = async () => {
  const [docs, result] = await axiosService.get({
    url: API.TOOLBOX.IA_PRICES,
  });

  return result;
};

// *****************************************************************************
// EXPORT
// *****************************************************************************

export default {
  catalogTool,
  toolboxAddToSet,
  getAiPrices,
};
